import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export const LockedPage = ({ title, description, preview }) => (
  <div className="fade-up space-y-6" data-testid="locked-page">
    <div className="flex flex-wrap items-center gap-3">
      <span className="flex h-10 w-10 items-center justify-center rounded-md bg-slate-200 text-slate-500">
        <Lock className="h-5 w-5" />
      </span>
      <div>
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        <p className="text-sm text-slate-500">{description}</p>
      </div>
    </div>

    <div className="relative overflow-hidden rounded-lg border border-slate-200 bg-white">
      <div className="pointer-events-none select-none opacity-40 blur-[1.5px]">{preview}</div>
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 p-6">
        <div className="max-w-sm rounded-lg border border-slate-200 bg-white p-6 text-center shadow-lg">
          <Lock className="mx-auto h-6 w-6 text-slate-400" />
          <h3 className="mt-3 text-lg font-semibold">Funzione bloccata nella demo</h3>
          <p className="mt-2 text-sm text-slate-500">
            Questa sezione è mostrata solo come anteprima. È completamente attiva nella versione
            per la tua attività.
          </p>
          <Button
            className="mt-4 w-full"
            data-testid="locked-cta-btn"
            onClick={() =>
              toast.info("Disponibile nella versione completa", {
                description: "Contatta il referente della demo per attivare questo modulo.",
              })
            }
          >
            Come sbloccarla
          </Button>
        </div>
      </div>
    </div>
  </div>
);
